// extracted by mini-css-extract-plugin
export default {"BubbleSmall":"Bubbles_BubbleSmall__r0FLW","BubbleMedium":"Bubbles_BubbleMedium__G8y-k","BubbleLarge":"Bubbles_BubbleLarge__xyovX"};